export default __webpack_public_path__ + "static/2-b32e679a75f68f58e3a0613635c691d1.png";